<template>
	<!-- 横屏时显示 -->
	<ContactPc v-if="isLandscape" />
	<!-- 竖屏时显示 -->
	<ContactPhone v-else />
</template>

<script>
	import ContactPc from '../../../components/Contact.vue'
	import ContactPhone from '../../../components/Contact_phone.vue'

	export default {
		name: 'Contact',
		components: {
			ContactPc,
			ContactPhone
		},
		data() {
			return {
				isLandscape: false
			}
		},
		mounted() {
			this.checkOrientation();
			window.addEventListener('resize', this.checkOrientation);
			window.addEventListener('orientationchange', this.checkOrientation);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.checkOrientation);
			window.removeEventListener('orientationchange', this.checkOrientation);
		},
		methods: {
			checkOrientation() {
				// 检查屏幕方向：宽度大于高度为横屏
				this.isLandscape = window.innerWidth > window.innerHeight;
			}
		}
	}
</script>
